import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AuthPage from "../pages/auth/page";
import RegisterPage from "../pages/auth/register/page";
import ForgotPasswordPage from "../pages/auth/forgot-password/page";
import ResetPasswordPage from "../pages/auth/reset-password/page";
import ActivateAccountPage from "../pages/auth/activate-account/page";
import ProfilePage from "../pages/profile/page";
import SettingsPage from "../pages/settings/page";
import CustomersPage from "../pages/customers/page";
import CustomerDetailPage from "../pages/customers/detail/page";
import OrdersPage from "../pages/orders/page";
import AnalyticsPage from "../pages/analytics/page";
import AccountingPage from "../pages/accounting/page";
import UsersPage from "../pages/users/page";
import CustomerServicePage from "../pages/customer-service/page";
import ManualApplicationPage from "../pages/manual-application/page";
import TermsPage from "../pages/terms/page";
import SharedOrderPage from "../pages/share-order/page";
import SharedCustomerPage from "../pages/share-customer/page";
import PrivacyPage from "../pages/privacy/page";
import HelpPage from "../pages/help/page";
import ContactPage from "../pages/contact/page";
import AboutPage from "../pages/about/page";
import DownloadPage from "../pages/download/page";
import ActivityListPage from "../pages/activity/page";
import ActivityDetailPage from "../pages/activity/detail/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import NettingReviewPage from "../pages/netting-review/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <AuthPage />, 
  },
  {
    path: "/register",
    element: <RegisterPage />, 
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />, 
  },
  {
    path: "/reset-password/:token",
    element: <ResetPasswordPage />, 
  },
  {
    path: "/activate-account",
    element: <ActivateAccountPage />, 
  },
  {
    // 订单分享摘要页：收件人没有账号，凭链接里的令牌直接打开，不套 ProtectedRoute
    path: "/share/order/:token",
    element: <SharedOrderPage />,
  },
  {
    // 客户订单核对页：收件人是「非注册用户身份的客户」，同样凭令牌打开、同样不套 ProtectedRoute
    path: "/share/customer/:token",
    element: <SharedCustomerPage />,
  },
  {
    // 站点根：已登录进工作台；未登录就地渲染登录页（兼作对外落地页），不再跳转 /login。
    // 落地页要和 /login 同一份组件，才不会出现两套文案各自漂移。
    path: "/",
    element: (
      <ProtectedRoute guest={<AuthPage />}>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/customers",
    element: (
      <ProtectedRoute>
        <CustomersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/customers/:id",
    element: (
      <ProtectedRoute>
        <CustomerDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/orders",
    element: (
      <ProtectedRoute>
        <OrdersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/analytics",
    element: (
      <ProtectedRoute>
        <AnalyticsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/accounting",
    element: (
      <ProtectedRoute>
        <AccountingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute>
        <UsersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/customer-service",
    element: (
      <ProtectedRoute>
        <CustomerServicePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/manual-application",
    element: (
      <ProtectedRoute>
        <ManualApplicationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/netting-review/:id",
    element: (
      <ProtectedRoute>
        <NettingReviewPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/terms",
    element: <TermsPage />, 
  },
  {
    path: "/privacy",
    element: <PrivacyPage />, 
  },
  {
    path: "/help",
    element: <HelpPage />, 
  },
  {
    path: "/contact",
    element: <ContactPage />, 
  },
  {
    path: "/about",
    element: <AboutPage />, 
  },
  {
    path: "/download",
    element: <DownloadPage />,
  },
  {
    // 活动列表与落地页：公开免登录（还没有账号的人才是要被活动引来的人）
    path: "/activity",
    element: <ActivityListPage />,
  },
  {
    path: "/activity/:key",
    element: <ActivityDetailPage />,
  },
  {

    path: "*",
    element: <NotFound />, 
  },
];

export default routes;
